import { createReducer } from 'redux-act';

import { setRedirect } from './redirect.actions';
import { IRedirectOptions } from './redirect.types';

export interface IRedirectState extends IRedirectOptions {}

export const initialState: IRedirectState = {
  url: null,
  timeout: 500,
  message: `You are leaving Alyce and will be automatically redirected to in a moment`,
  title: 'Your gift is confirmed',
};

const reducer = createReducer<IRedirectState>({}, initialState);

reducer.on(setRedirect, (state, payload) => ({
  ...state,
  ...initialState,
  ...payload,
  message:
    payload.message ||
    `You are leaving Alyce and will be automatically redirected to <a href="${payload.url}">${payload.url}</a> in a moment`,
}));

export default reducer;
